<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ constructionDrawingDetail.projectName }}</td>
						<th>标段名称</th>
						<td>{{ constructionDrawingDetail.bidSectionName }}</td>
						<th>施工图审查环节编码</th>
						<td>{{ constructionDrawingDetail.linkCode }}</td>
					</tr>
					<tr>
						<th>审查项目建设单位名称</th>
						<td>{{ constructionDrawingDetail.constructionUnitName }}</td>
						<th>建设单位组织机构代码</th>
						<td>{{ constructionDrawingDetail.constructionUnitCode }}</td>
						<th>所在地市</th>
						<td>{{ constructionDrawingDetail.cityName }}</td>
					</tr>
					<tr>
						<th>所在区县</th>
						<td>{{ constructionDrawingDetail.countyName }}</td>
						<th>项目总投资（万元）</th>
						<td>{{ constructionDrawingDetail.biddingMoney }}</td>
						<th>项目总面积（平方米）</th>
						<td>{{ constructionDrawingDetail.constructionArea }}</td>
					</tr>
					<tr>
						<th>建设性质</th>
						<td>{{ constructionDrawingDetail.designPropertyName }}</td>
						<th>审查项目分类</th>
						<td>{{ constructionDrawingDetail.reviewProjectTypeName }}</td>
						<th>工程用途</th>
						<td>{{ constructionDrawingDetail.projectPurposeName }}</td>
					</tr>
					<tr>
						<th>建设规模</th>
						<td>{{ constructionDrawingDetail.designScale }}</td>
						<th>施工图审查合格书编号</th>
						<td>{{ constructionDrawingDetail.reviewCerCode }}</td>
						<th>施工图审查机构名称</th>
						<td>{{ constructionDrawingDetail.reviewOrgName }}</td>
					</tr>
					<tr>
						<th>施工图审查机构组织机构代码</th>
						<td>{{ constructionDrawingDetail.reviewOrgCode }}</td>
						<th>施工图审查机构资质证书编号</th>
						<td>{{ constructionDrawingDetail.reviewOrgCerCode }}</td>
						<th>承揽工程审图业务资质项编码</th>
						<td>{{ constructionDrawingDetail.qualificationCode }}</td>
					</tr>
					<tr>
						<th>承揽此工程项目业务的资质名称</th>
						<td>{{ constructionDrawingDetail.qualificationName }}</td>
						<th>审查项目名称</th>
						<td>{{ constructionDrawingDetail.reviewProjectName }}</td>
						<th>审查项目地址</th>
						<td>{{ constructionDrawingDetail.reviewProjectAddress }}</td>
					</tr>
					<tr>
						<th>工程类别</th>
						<td>{{ constructionDrawingDetail.projectCategoryName }}</td>
						<th>工程类型</th>
						<td>{{ constructionDrawingDetail.projectTypeName }}</td>
						<th>设计等级</th>
						<td>{{ constructionDrawingDetail.designGradeName }}</td>
					</tr>
					<tr>
						<th>申请报审时间</th>
						<td>{{ constructionDrawingDetail.reportTime }}</td>
						<th>一审结果</th>
						<td>{{ constructionDrawingDetail.reviewResult }}</td>
						<th>一审完成时间</th>
						<td>{{ constructionDrawingDetail.finishTime }}</td>
					</tr>
					<tr>
						<th>一审违反一般性条文数</th>
						<td>{{ constructionDrawingDetail.universalityNumber }}</td>
						<th>一次审查时违反强条数</th>
						<td>{{ constructionDrawingDetail.compulsoryNumber }}</td>
						<th>一次审核是否通过</th>
						<td>{{ constructionDrawingDetail.reviewStatus }}</td>
					</tr>
					<tr>
						<th>一次审查时违反的强条条目</th>
						<td>{{ constructionDrawingDetail.compulsoryItem }}</td>
						<th></th>
						<td></td>
						<th></th>
						<td></td>
					</tr>
					<tr>
						<th>几审通过</th>
						<td>{{ constructionDrawingDetail.reviewNumber }}</td>
						<th>终审完成时间</th>
						<td>{{ constructionDrawingDetail.finalFinishTime }}</td>
						<th>审查完成日期</th>
						<td>{{ constructionDrawingDetail.reviewFinishTime }}</td>
					</tr>
				</table>
			</div>

			<!-- 批量数据切换 -->
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in detailTabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTabIndex === index }]"
							@click="activeTabIndex = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- 企业主体信息 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 0 }]">
						<data-table
							:table-data="constructionDrawingDetail.constructionEnterpriseList"
							:column="enterpriseColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
					<!-- 专业技术人员 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 1 }]">
						<data-table
							:table-data="constructionDrawingDetail.constructionProfessionalList"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { transObject } from '@/utils/index'
	import { getConstructionDrawingDetail } from '@/api/qualificationQuery/project'

	// 施工图审查详情
	export default {
		name: 'ReviewDetails',
		components: {
			DataTable,
			NonbindVip,
			NonbindSvip
		},
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				detailTabs: [{ name: '企业主体信息' }, { name: '专业技术人员' }],
				activeTabIndex: 0,

				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 施工图审查详情对象
				constructionDrawingDetail: {
					// 项目名称
					projectName: '',
					// 标段名称
					bidSectionName: '',
					// 施工图审查环节编码
					linkCode: '',
					// 审查项目建设单位名称
					constructionUnitName: '',
					// 建设单位组织机构代码
					constructionUnitCode: '',
					// 所在地市
					cityCode: '',
					cityName: '',
					// 所在区县
					countyCode: '',
					countyName: '',
					// 项目总投资（万元）
					biddingMoney: '',
					// 项目总面积（平方米）
					constructionArea: '',
					// 建设性质
					designProperty: '',
					designPropertyName: '',
					// 审查项目分类
					reviewProjectType: '',
					reviewProjectTypeName: '',
					// 工程用途
					projectPurpose: '',
					projectPurposeName: '',
					// 建设规模
					designScale: '',
					// 施工图审查机构名称
					reviewOrgName: '',
					// 施工图审查机构组织机构代码
					reviewOrgCode: '',
					// 施工图审查机构资质证书编号
					reviewOrgCerCode: '',
					// 承揽工程审图业务资质项编码
					qualificationCode: '',
					// 承揽此工程项目业务的资质名称
					qualificationName: '',
					// 审查项目名称
					reviewProjectName: '',
					// 审查项目地址
					reviewProjectAddress: '',
					// 工程类别
					projectCategory: '',
					projectCategoryName: '',
					// 工程类型
					projectType: '',
					projectTypeName: '',
					// 设计等级
					designGrade: '',
					designGradeName: '',
					// 申请报审时间
					reportTime: '',
					// 一审结果
					reviewResult: '',
					// 一审完成时间
					finishTime: '',
					// 一审违反一般性条文数
					universalityNumber: '',
					// 一次审查时违反强条数
					compulsoryNumber: '',
					// 一次审核是否通过
					reviewStatus: '',
					// 一次审查时违反的强条条目
					compulsoryItem: '',
					// 几审通过
					reviewNumber: '',
					// 终审完成时间
					finalFinishTime: '',
					// 审查完成日期
					reviewFinishTime: '',
					// 施工图审查合格书编号
					reviewCerCode: '',
					// 企业主体信息
					constructionEnterpriseList: [],
					// 专业技术人员
					constructionProfessionalList: []
				},
				enterpriseColumns: [
					{ label: '单位类型', prop: 'unitType', align: 'center' },
					{ label: '单位名称', prop: 'unitName', align: 'center' },
					{ label: '社会统一代码', prop: 'unitCode', align: 'center' },
					{ label: '负责人', prop: 'principalName', align: 'center' }
				],
				personColumns: [
					{ label: '姓名', prop: 'name', align: 'center' },
					{ label: '证件号码', prop: 'name', align: 'center' },
					{ label: '所在企业', prop: 'name', align: 'center' },
					{ label: '承担角色', prop: 'name', align: 'center' },
					{ label: '从事专业名称', prop: 'idCard', align: 'center' }
				],
				enterpriseList: [], //企业主体信息
				professionalList: [], //专业技术人员
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryConstructionPermitDetail()
		},
		methods: {
			// 查询合同登记详情
			handleQueryConstructionPermitDetail() {
				this.loading = true
				const params = {
					constructionDrawingReviewId: this.id
				}

				getConstructionDrawingDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.constructionDrawingDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
